import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-confian-card',
  templateUrl: './confian-card.component.html',
  styleUrls: ['./confian-card.component.scss']
})
export class ConfianCardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
